module.exports = __webpack_public_path__ + "img/download.55221557.png";